import classNames from 'classnames/bind';

import styles from './Knowledge.module.scss';
import {
    CodeIcon,
    JavascriptIcon,
    NodeIcon,
    ReactIcon,
    ScssIcon,
    UbuntuIcon,
} from '~/components/Icons/Icons';
import { ChalkBoardIcon } from '../Icons/Icons';
import images from '~/assets/images';

const cx = classNames.bind(styles);

function Knowledge() {
    return (
        <div className={cx('wrapper')} id="education">
            <div className={cx('inner', 'grid', 'wide')}>
                <div className={cx('row')}>
                    <div className={cx('left', 'col', 'p-6', 't-12', 'm-12')}>
                        <div className={cx('left-header')}>
                            <h1>GIÁO DỤC</h1>
                        </div>
                        <div className={cx('left-body')}>
                            <div className={cx('university')}>
                                <div className={cx('header')}>
                                    <div className={cx('header-icon')}>
                                        <ChalkBoardIcon className={cx('chalkboardicon')} />
                                    </div>
                                    <div>
                                        <h3>Trường Đại Học Bách Khoa - ĐHQG Tp.Hồ Chí Minh</h3>
                                        <span>Tháng 08/2019 - nay</span>
                                    </div>
                                </div>
                                <p>
                                    Sau khoảng thời gian học tập không mấy mệt mỏi cũng như không
                                    mấy điểm cao ở trường cấp 3 thì mình quyết định sẽ thi vào Bách
                                    khoa, với ước mơ bấy giờ là trở thành anh kỹ sư thợ máy🙂...
                                    Nhưng thời gian dần trôi... đồng thời cuốn trôi theo nhưng giấc
                                    mơ ngày ấy bởi cậu bạn rủ rê mình "chơi" code, ban đầu thấy khô
                                    khan ghê nhưng sau đó cũng thấy khô nhưng đỡ hơn nhiều...
                                </p>
                            </div>
                            <div className={cx('f8')}>
                                <div className={cx('header')}>
                                    <div className={cx('header-icon')}>
                                        <img src={images.f8} alt="F8Logo" />
                                    </div>
                                    <div>
                                        <h3>F8 | Front-end Developement</h3>
                                        <span>Tháng 10/2022 - nay</span>
                                    </div>
                                </div>
                                <p>
                                    Cũng nhờ ơn ông bạn kia mà mình biết đến F8 - Một trang web học
                                    lập trình từ cơ bản đến nâng cao, lộ trình rõ ràng cho khóa
                                    Front-end Dev và Back-end Dev, hơn nữa lại miễn phí. Sau khi học
                                    tập tại đây, mình đã học được rất nhiều kiến thức bổ ích. Là một
                                    người mới hoàn toàn mình gặp rất nhiều khó khăn trong quá trình
                                    học tập, nhưng may mắn được các bạn trong cộng đồng cũng như các
                                    video của Anh Sơn dễ hiểu nên quá trình học tập trở nên dễ dàng
                                    hơn một chút. Rất cảm ơn Anh Sơn và cộng đồng F8!
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={cx('right', 'col', 'p-6', 't-12', 'm-12')}>
                        <div className={cx('right-header')}>
                            <h1>KỸ NĂNG</h1>
                            <p>
                                Dưới đây là một số kỹ năng cơ bản về lập trình mà mình đã học được.
                                Mình tin rằng sự kiên trì là yếu tố then chốt để đạt được thành
                                công. Những kinh nghiệm ban đầu đã giúp mình xác định đúng hướng và
                                phát triển các kỹ năng cần thiết để theo đuổi sự nghiệp trong lĩnh
                                vực đang theo đuổi.
                            </p>
                        </div>
                        <div className={cx('right-body')}>
                            <div className={cx('body-items')}>
                                <span className={cx('title')}>Development</span>
                                <div className={cx('body-item', 'html-css')}>
                                    <div className={cx('icon-before-name')}>
                                        <CodeIcon />
                                    </div>
                                    <span>HTML</span>
                                </div>
                                <div className={cx('body-item', 'css')}>
                                    <div className={cx('icon-before-name')}>
                                        <ScssIcon />
                                    </div>
                                    <span>CSS, SCSS</span>
                                </div>
                                <div className={cx('body-item', 'js')}>
                                    <div className={cx('icon-before-name')}>
                                        <JavascriptIcon className={cx('js-icon')} />
                                    </div>
                                    <span>JavaScript</span>
                                </div>
                                <div className={cx('body-item', 'react')}>
                                    <div className={cx('icon-before-name')}>
                                        <ReactIcon className={cx('react-icon')} />
                                    </div>
                                    <span>ReactJS</span>
                                </div>
                                <div className={cx('body-item', 'node')}>
                                    <div className={cx('icon-before-name')}>
                                        <NodeIcon className={cx('node-icon')} />
                                    </div>
                                    <span>NodeJS</span>
                                </div>
                            </div>
                            <div className={cx('body-items')}>
                                <span className={cx('title')}>Design</span>
                                <div className={cx('body-item', 'inkscape-wrap')}>
                                    <div className={cx('icon-before-name')}>
                                        <img
                                            className={cx('inkscape')}
                                            src="https://media.inkscape.org/static/images/inkscape-logo.svg"
                                            alt="inkscape"
                                        />
                                    </div>
                                    <span>Inkscape</span>
                                </div>
                            </div>
                            <div className={cx('body-items')}>
                                <span className={cx('title')}>Systems</span>
                                <div className={cx('body-item', 'ubuntu')}>
                                    <div className={cx('icon-before-name')}>
                                        <UbuntuIcon />
                                    </div>
                                    <span>Ubuntu</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Knowledge;
